<template lang="pug">
v-alert.mt-4.secondary.lighten-1.mb-0(
  v-if="alert"
  v-bind="alert.attrs"
  border="top"
  colored-border
)
  div(:class="`${alert.attrs.color}--text`"): strong  "{{ message.text }}"
  strong {{ alert.text }}
  .white--text(v-if="alert.type === 2") {{ alert.answer }}
  template(#append v-if="alert.type === 3")
    v-btn(icon loading color="info" small)
  v-row.ma-0(v-if="alert.actions").align-center
    component.mt-0.mr-2(
      v-for="(action, idx) in alert.actions"
      :key="idx"
      v-bind="action.attrs"
      v-on="extendListeners[idx]"
    )
      span(v-if="action.text") {{ action.text }}
</template>
<script>
import { ALERTS } from '../glossary';

export default {

  inject: ['chat'],

  props: {
    message: { type: Object, default: null },
  },

  data() {
    return {
      alert: null,
    };
  },
  computed: {
    extendListeners() {
      const { actions = [] } = this.alert || { actions: [] };
      if (actions.length) {
        const result = actions.map((action) => {
          if (action.listeners) {
            const resultAction = Object.entries(action.listeners).reduce((acc, [key, func]) => {
              const extendedFunction = (val) => {
                const { key: optionKey, value } = func(val);
                this.$set(this.chat.alertOptions, optionKey, value);
              };
              return { ...acc, [key]: extendedFunction };
            }, {});
            return resultAction;
          }
          return null;
        });
        return result;
      }
      return {};
    },
  },
  watch: {
    message(val) {
      if (val) {
        this.setAlertOption();
      } else this.alert = null;
    },
  },
  created() {
  },
  methods: {
    async setAlertOption() {
      let alert = null;
      const { gpt_request: gptRequest, fromMe } = this.message;
      if (gptRequest && !gptRequest.is_processed && !fromMe) {
        this.chat.setAlertMessage(this.message);
        const { answer } = gptRequest.response;
        const type = answer === 'no-answer' ? 1 : 2;
        alert = {
          answer,
          type,
          ...ALERTS[type],
        };
        this.alert = alert;
      }
    },
  },
};
</script>
